'use client';

import React from "react";
import { useTeam } from "../internals";

const ROLE_LABEL_KEY = {
  owner: "role_owner",
  admin: "role_admin",
  manager: "role_manager",
  staff: "role_staff",
  field_worker: "role_field_worker",
};

const ROLE_DESC_KEY = {
  owner: "role_desc_owner",
  admin: "role_desc_admin",
  manager: "role_desc_manager",
  staff: "role_desc_staff",
  field_worker: "role_desc_field_worker",
};

// Big tap-target role cards with a one-line plain-English description
// each — idiot-proof picking over a tiny dropdown.
export const RolePicker = ({ roles, value, onChange, disabled }) => {
  const { copy } = useTeam();
  return (
    <div className="space-y-2" data-testid="role-picker">
      {roles.map((r) => {
        const selected = value === r;
        return (
          <button
            key={r}
            type="button"
            data-testid={`role-option-${r}`}
            disabled={disabled}
            onClick={() => onChange(r)}
            className={`flex w-full items-start gap-3 rounded-lg border px-3 py-2.5 text-left transition-colors ${
              selected ? "border-zinc-900 bg-zinc-50" : "border-zinc-200 hover:bg-zinc-50"
            } ${disabled ? "cursor-not-allowed opacity-60" : ""}`}
          >
            <span
              className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${
                selected ? "border-zinc-900" : "border-zinc-300"
              }`}
            >
              {selected && <span className="h-2 w-2 rounded-full bg-zinc-900" />}
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-semibold text-zinc-900">
                {copy[ROLE_LABEL_KEY[r]] || r}
              </span>
              <span className="block text-xs text-zinc-500">{copy[ROLE_DESC_KEY[r]]}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
};
